/** Service-worker registration + "update available" signal (the new SW waits until the owner chooses to reload). */
let waiting: ServiceWorker | null = null;
const listeners = new Set<() => void>();
const set = (w: ServiceWorker | null) => { waiting = w; for (const fn of listeners) fn(); };

export const updateStore = {
  subscribe(fn: () => void) { listeners.add(fn); return () => { listeners.delete(fn); }; },
  get: () => waiting,
  apply() {
    if (!waiting) return;
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => { if (!reloaded) { reloaded = true; window.location.reload(); } });
    waiting.postMessage({ type: "SKIP_WAITING" });
  },
};

export async function registerServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    const track = (sw: ServiceWorker | null) => {
      if (!sw) return;
      sw.addEventListener("statechange", () => { if (sw.state === "installed" && navigator.serviceWorker.controller) set(sw); });
    };
    if (reg.waiting && navigator.serviceWorker.controller) set(reg.waiting);
    track(reg.installing);
    reg.addEventListener("updatefound", () => track(reg.installing));
    const check = () => { void reg.update().catch(() => undefined); };
    setInterval(check, 30 * 60_000);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
  } catch {
    /* SW is an enhancement; the app works without it. */
  }
}
